import { collection, getDocs } from "firebase/firestore";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import BenefitsClupp from "./BenefitsClupp";
import { db } from "../../../firebase";

const landingId = "CF_CLUPP_BENEFITS";

const onLoad = async ({ session, landedAt, uid }) => {
  const prevAnswers = {};
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;
  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });

  return {
    userId: uid,
    ...prevAnswers,
    landedAt,
    prevForm,
    currentLanding: landingId
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(await nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <BenefitsClupp state={state} setState={setState} />
);

const nextPage = async (props) => {
  const claimsCollection = collection(db, `users/${props.uid}/claims`);
  const claimsSnapshot = await getDocs(claimsCollection);
  if (claimsSnapshot.docs.length > 0) {
    return `/formulario/cancelacion/siniestros?uid=${props.uid}`;
  }
  return `/formulario/cancelacion/servicio?uid=${props.uid}`;
};
const prevPage = (props) => `/formulario/cancelacion/lealtad?uid=${props.uid}`;

const fieldsStructure = [];

const benefitsCluppProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default benefitsCluppProps;
